import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {ButtonThemeEnum} from "./button-theme-enum";

@Component({
    selector: 'yo-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    standalone: false
})
export class ButtonComponent implements OnInit {

  @Input() type: "submit" | "button" = "button";
  @Input() name: string = "";
  @Input() buttonId: string = "";
  @Input() buttonClass: string;
  @Input() iconClass: string = "";
  @Input() iconPos: "left" | "right" = "left";
  @Input() label: string = "";
  @Input() tooltip: string = "";
  @Input() disabled: boolean = false;
  @Input() size: "" | "small" = "";
  @Output() onClick = new EventEmitter;

  @Input() theme !: ButtonThemeEnum;

  public _buttonClass = "";
  public _iconClass = "";

  constructor() {
  }

  ngOnInit() {
    this.initButtonClasses();
  }

  initButtonClasses = () => {
    let defaultClass = "custom-button";

    if (this.size)
      defaultClass += "-" + this.size;

    if (this.theme != null)
      this._buttonClass = defaultClass
    else
      this._buttonClass = defaultClass + " " + this.buttonClass;

    if (!this.label && !this.iconClass)
      this._iconClass = "fas fa-question";
    else
      this._iconClass = this.iconClass;
  }

  onButtonClick = (event): void => {
    this.onClick.emit(event);
  }

  getButtonClassCssClass() {
    this.initButtonClasses();

    let cssClasses: String[] = [];

    cssClasses.push(this._buttonClass);

    if (this.iconPos === 'right')
      cssClasses.push("reverse");

    if (this.theme != null)
      cssClasses.push(this.theme);

    return cssClasses.join(" ");
  }

}
